import { styled } from '@mui/material/styles'

export const FieldWrapper = styled('div')`
  display: ${props => props.$row ? 'block' : 'grid'};
  grid-template-columns: ${props => props.$row ? '1fr' : '63px 1fr'};
  column-gap: ${props => props.$row ? '0' : '26px'};
  row-gap: 6px;
  align-items: start;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 520px) {
    grid-template-columns: 1fr;
    grid-template-rows: auto auto auto auto;
    column-gap: 0;
  }
`

export const Label = styled('label')`
    grid-column: 1;
    grid-row: 1;
    align-self: center;
    font-size: 14px;
    line-height: 24px;
    color: #2b2b2b;
    font-weight: 500;
    white-space: nowrap;
    text-align: left;

    @media (max-width: 520px) {
        grid-column: 1;
        grid-row: 1;
        align-self: start;
        margin-bottom: 6px;
    }
`

export const InputCell = styled('div')`
  grid-column: 2;
  grid-row: 1;
  display: block;
  width: 100%;
  box-sizing: border-box;

  ${props => props.$row && `
    grid-column: 1;
    grid-row: 1;
    display: block;
  `}

  @media (max-width: 520px) {
    grid-column: 1;
    grid-row: 1;
    display: block;
  }
`

export const StyledInput = styled('input')`
  box-sizing: border-box;
  display: block;
  width: 100%;
  padding: 8px 12px;
  height: 36px;
  pointer-events: ${props => props.disabled ? 'none' : 'initial'};
  font-family: 'Inter';
  border: 1px solid ${props => props['aria-invalid'] ? '#F26464' : '#CFD6DD'};
  border-radius: 8px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  margin: ${props => props.margin || '0'};

  &::placeholder {
    color: #7E8B99;
    opacity: 1;
  }

  color: #272E35;
  background: #FFFFFF;
  outline: none;
  transition: border-color 0.15s;

  &:hover:not(:disabled):not(:focus) {
    border-color: #6792F4;
  }

  &:focus {
    border-color: #6792F4;
    box-shadow: 0 0 0 0.5px #6792F4;
  }

  &:disabled {
    background: #F5F7F9;
    color: #9EA8B3;
    border-color: #E9ECEF;
  }
`

export const Comment = styled('div')`
  grid-column: 2;
  grid-row: 3;
  margin-top: 0;
  font-size: 12px;
  line-height: 16px;
  color: #7E8B99;
  max-width: 100%;
  word-break: break-word;

  @media (max-width: 520px) {
    grid-column: 1;
    grid-row: 4;
  }
`

export const ErrorInline = styled('div')`
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: normal;
  grid-column: 2;
  grid-row: 2;
  margin-top: 6px;
  min-height: 20px;

  ${props => props.$row && `
    grid-column: 1;
    grid-row: 2;
  `}

  @media (max-width: 520px) {
    grid-column: 1;
    grid-row: 2;
  }
`

export const ErrorText = styled('div')`
  color: #C53434;
  font-size: 12px;
  line-height: 16px;
  overflow-wrap: anywhere;
`
